<template>
  <b-modal 
  :visible="showModal" 
  :hide-footer="true" 
  @hide="hideModal" 
  class="modal-content-t"
  size="lg"
  >
    <template #modal-title>
      <h5
        class="modal-title"
        style="color: #425994; font-size: 22px; font-weight: 600"
      >
        Cadastro de Cupom
      </h5>
    </template>
    <template #modal-header-close>
      <button
        type="button"
        class="close"
        @click="hideModal"
        style="color: #4fa935; font-size: 24px; font-weight: bold"
      >
        ×
      </button>
    </template>
    <div>
      <div>
        <ValidationObserver v-slot="{ invalid }">
          <form class="mt-2">
            <div
              style="
                display: flex;
                gap: 10px;
                align-items: start;
                font-size: 18px;
              "
            >
              <div style="width: 332px" class="form-group">
                <ValidationProvider
                  name="nome"
                  rules="required"
                  v-slot="{ errors, classes }"
                >
                  <label class="nome-cupom">Nome do Cupom</label>
                  <input
                    v-model="cupom.codigo"
                    :disabled="cupom.id"
                    type="text"
                    style="text-decoration: uppercase"
                    class="form-control"
                    :class="classes"
                  />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group" style="width:210px">
                <ValidationProvider
                  name="quantidade"
                  rules="required"
                  v-slot="{ errors, classes }"
                >
                  <label class="nome-cupom">Quantidade</label>
                  <input
                    v-model="cupom.quantidade"
                    type="tel"
                    max="10000"
                    min="1"
                    v-mask="'#####'"
                    class="form-control"
                    :class="classes"
                  />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group" style="width:210px">
                <ValidationProvider
                  name="quantidade"
                  rules="required"
                  v-slot="{ errors, classes }"
                >
                  <label class="nome-cupom">Percentual (%)</label>
                  <input
                    v-model="cupom.percentual"
                    type="tel"
                    max="100"
                    min="1"
                    :disabled="cupom.id"
                    v-mask="'###'"
                    class="form-control"
                    :class="classes"
                  />
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div
              style="
                display: flex;
                gap: 10px;
                align-items: start;
                font-size: 18px;
              "
            >
              <div style="width: 332px" class="form-group">
                <label class="nome-cupom">Tipo de Cupom</label>
                <ValidationProvider
                  name="produto"
                  rules="required"
                  v-slot="{ errors, classes }"
                >
                  <select
                    :disabled="cupom.produto"
                    class="form-control"
                    v-model="produto"
                    :class="classes"
                  >
                    <option :value="null">Selecione</option>
                    <option value="SEGURO">Seguro</option>
                    <option value="REGISTRO">Registro</option>
                  </select>
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div style="width:210px" class="form-group">
                <ValidationProvider
                  rules="required"
                  name="inicio"
                  v-slot="{ errors, classes }"
                  ><label class="nome-cupom">Data Inicio da vigência</label>
                  <input
                    type="tel"
                    class="form-control"
                    :class="classes"
                    v-model="dataInicio"
                    v-mask="'##/##/####'"
                    placeholder="início"
                    autocomplete="nope"
                  />
                  <span class="ml-3 invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div style="width:210px" class="form-group">
                <ValidationProvider
                  rules="required"
                  name="fim"
                  v-slot="{ errors, classes }"
                  ><label class="nome-cupom">Data de expiração</label>
                  <input
                    type="tel"
                    class="form-control"
                    :class="classes"
                    v-model="dataFim"
                    v-mask="'##/##/####'"
                    placeholder="fim"
                    autocomplete="nope"
                  />
                  <span class="ml-3 invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div style="
                display: flex;
                gap: 10px;
                align-items: start;
                font-size: 18px;
              ">
              <div style="width: 332px" v-if="produto == 'REGISTRO'" class="form-group">
                <label class="nome-cupom">Tipo do plano</label>
                <ValidationProvider
                  name="plano"
                  rules="required"
                  v-slot="{ errors, classes }"
                >
                  <select
                    :disabled="cupom.produto"
                    class="form-control"
                    v-model="idPlano"
                    :class="classes"
                  >
                    <option :value="null">Selecione</option>
                    <option value="40f2fa99-ab2c-40a3-9206-8c8640c8253a">
                      Premium
                    </option>
                    <option value="fbfcf99f-2a25-4224-bb46-76b9c85bc741">
                      Starter
                    </option>
                  </select>
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <button
                  type="submit"
                  class="btn btn-outline-danger"
                  style="width: 199;
height: 40;
border-radius: 4px;
border-width: 1px;
angle: 0 deg;
opacity: 1;
gap: 8px;
padding-top: 8px;
padding-right: 16px;
padding-bottom: 8px;
padding-left: 16px;
"
                  @click.prevent="hideModal(false)"
                  :disabled="loadingText"
                >
                  <span>Cancelar</span>
                </button>
              </div>
              <div class="col-6 text-right">
                <button
                  type="submit"
                  @click="salvar()"
                  class="btn btn-success" style="width: 199;
height: 40;
border-radius: 4px;
angle: 0 deg;
opacity: 1;
gap: 8px;
padding-top: 8px;
padding-right: 24px;
padding-bottom: 8px;
padding-left: 24px;
"
                  :disabled="invalid || loadingText"
                >
                  <span v-if="!loadingText && cupom.id">Atualizar cupom</span>
                  <span v-else-if="!loadingText && !cupom.id"
                    >Cadastrar cupom</span
                  >
                  <span v-else>Por favor aguarde...</span>
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import config from "../../config";
import formatacaoData from "../../helpers/formatacaoData";
import moment from "moment";
export default {
  props: ["showModal", "cupom"],
  data() {
    return {
      historico: [],
      config,
      formatacaoData,
      loading: false,
      dataFim: undefined,
      dataInicio: undefined,
      loadingText: false,
      produto: null,
      idPlano: null,
    };
  },
  watch: {
    "cupom.codigo": function (value) {
      this.cupom.codigo = value.toUpperCase().trim();
    },
    produto: function (newValue) {
      if (newValue != "REGISTRO") {
        this.idPlano = null;
      }
    },
    showModal: function (newValue) {
      if (newValue) {
        if (this.cupom && this.cupom?.produto) {
          this.produto = this.cupom?.produto;
        }
        if (this.cupom && this.cupom?.idPlano) {
          this.idPlano = this.cupom?.idPlano;
        }

        this.dataInicio = undefined;
        this.dataFim = undefined;
        if (this.cupom && this.cupom.dataInicio) {
          const dataInicio = moment(this.cupom.dataInicio).format("DD/MM/YYYY");
          this.dataInicio = dataInicio;
        }
        if (this.cupom && this.cupom.dataFim) {
          const dataFim = moment(this.cupom.dataFim).format("DD/MM/YYYY");
          this.dataFim = dataFim;
        }
      }
    },
  },
  methods: {
    hideModal(value) {
      this.$emit("hideCupom", {
        modificou: value != true ? false : value,
      });
      this.produto = null;
      this.idPlano = null;
    },
    async salvar() {
      this.loadingText = true;
      try {
        let datainicio = this.dataInicio
          ? moment(this.dataInicio, "DD/MM/YYYY").format("YYYY-MM-DD")
          : undefined;
        let datafim = this.dataFim
          ? moment(this.dataFim, "DD/MM/YYYY").format("YYYY-MM-DD")
          : undefined;

        if (!datafim || !datainicio || datainicio > datafim) {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: "Por verifique a Data Inicio da vigência e a Data de expiração! Precisam ser um periodo valido!",
          });
          this.loadingText = false;
          return;
        }
        const data = {
          id: this.cupom.id,
          codigo: this.cupom.codigo,
          dataInicio: datainicio,
          dataFim: datafim,
          quantidade: this.cupom.quantidade,
          percentual: this.cupom.percentual,
          produto: this.produto,
          idPlano: this.idPlano,
        };

        let mensagem = "";
        if (!data.id) {
          await axios.post(`${config.API_URLV2}/cupom`, data);
          mensagem = "O cupom foi cadastrado com sucesso!!";
        } else {
          await axios.put(`${config.API_URLV2}/cupom`, data);
          mensagem = "O cupom foi atualizado com sucesso!!";
        }
        Swal.fire("Cupom", mensagem, "success");
        this.hideModal(true);
        this.loadingText = false;
      } catch (error) {
        this.loadingText = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error?.response?.data?.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.nome-cupom {
  font-weight: 500;
  font-size: 16px;
  color: #1e293b;
}
.modal-header .close {
  color: #4fa935;
  font-size: 22px;
  font-weight: bold;
  opacity: 2 !important; /* mantém a cor visível */
}


</style>
